document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".section-menu__quicklinks li a");
  const listItemLinks = document.querySelectorAll(
    ".section-menu__quicklinks li"
  );
  const hashValue = window.location.hash.substring(1);
  const banner = document.querySelector(".banner-meta-object");
  const titleBanner = banner.querySelector(".hero__title");
  const descriptionBanner = banner.querySelector(".hero__rte");
  const heroImageBanner = banner.querySelector('.image__hero__pane img');
  const iconBanner = banner.querySelector("figure.image-wrapper img");
  const dataScript = document.querySelector("script[data-section-menu]");

  const metaobjectData = JSON.parse(dataScript.textContent);

  if (listItemLinks) {
    listItemLinks.forEach((link) => {
      link.addEventListener("click", function (event) {
        listItemLinks.forEach((item) => item.classList.remove("active"));
        link.classList.add("active");
        const dataId = link.dataset.id;

        const matchingMetaobject = metaobjectData.find((metaobject) => {
          const id = metaobject.name
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-");
          return id === dataId;
        });
        if (matchingMetaobject) {
          heroImageBanner.srcset = matchingMetaobject.hero_image;
          heroImageBanner.src = matchingMetaobject.hero_image;
          titleBanner.innerHTML = matchingMetaobject.heading;
          descriptionBanner.innerHTML = matchingMetaobject.description;
          if (matchingMetaobject.icon) {
            iconBanner.srcset = matchingMetaobject.icon;
            iconBanner.src = matchingMetaobject.icon;
          } else {
            iconBanner.srcset = metaobjectData[0].icon;
            iconBanner.src = metaobjectData[0].icon;
          }
        }
      });
    });
  }

  if (hashValue) {
    links.forEach((link) => {
      const linkText = link.textContent
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-");
      if (linkText === hashValue.toLowerCase()) {
        link.parentElement.classList.add("active");
      }
    });
    const matchingMetaobject = metaobjectData.find((metaobject) => {
      const id = metaobject.name
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-");
      return id === hashValue;
    });
    if (matchingMetaobject) {
      heroImageBanner.srcset = matchingMetaobject.hero_image;
      heroImageBanner.src = matchingMetaobject.hero_image;
      titleBanner.innerHTML = matchingMetaobject.heading;
      descriptionBanner.innerHTML = matchingMetaobject.description;
      if (matchingMetaobject.icon) {
        iconBanner.srcset = matchingMetaobject.icon;
        iconBanner.src = matchingMetaobject.icon;
      } else {
        iconBanner.srcset = metaobjectData[0].icon;
        iconBanner.src = metaobjectData[0].icon;
      }
    }
  } else {
    links[0].parentElement.classList.add("active");
  }
});
